import { doGet, doLogin, doPost, doPostWithoutHeader } from './services';

export const AuthenticationController = {
	profiles: (body, params) => {
		return doLogin('users/sign-up/', body, params);
	},
	getProfileInfo: () => {
		return doGet('users/');
	},
	changePassword: body => {
		return doPost('authentication/change-password/', body);
	},
	forgetPassword: body => {
		return doPostWithoutHeader('authentication/forgot-password/', body);
	},
};
